import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import moment from 'moment';
import { DisparoService } from '../disparo.service';
import { MatIconModule } from '@angular/material/icon';
import { AlertComponent } from '../../../../alert/alert.component';
import { LoadingModalComponent } from '../../../../loading-modal/loading-modal.component';

@Component({
  selector: 'app-fire-oficial-csv',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    AlertComponent,
    LoadingModalComponent,
  ],
  templateUrl: './fire-oficial-csv.component.html',
  styleUrls: ['./fire-oficial-csv.component.scss'],
  providers: [DisparoService],
})
export class FireOficialCsvComponent implements OnInit {
  @Output() closeModal: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent)
  loadingModalComponent!: LoadingModalComponent;

  //Variaveis de exibicao e configuracao
  public stepForm: number = 1;
  public listChannels: Array<any> = [];

  //Variaveis para o formulario
  public countrys: Array<any> = [
    { name: 'BRA', code: '55' }, // Brasil
    { name: 'USA', code: '1' }, // Estados Unidos
    { name: 'CAN', code: '1' }, // Canadá
    { name: 'ARG', code: '54' }, // Argentina
    { name: 'MEX', code: '52' }, // México
    { name: 'GBR', code: '44' }, // Reino Unido
    { name: 'FRA', code: '33' }, // França
    { name: 'GER', code: '49' }, // Alemanha
    { name: 'ITA', code: '39' }, // Itália
    { name: 'ESP', code: '34' }, // Espanha
    { name: 'CHN', code: '86' }, // China
    { name: 'JPN', code: '81' }, // Japão
    { name: 'IND', code: '91' }, // Índia
    { name: 'AUS', code: '61' }, // Austrália
    { name: 'ZAF', code: '27' }, // África do Sul
    { name: 'RUS', code: '7' }, // Rússia
    { name: 'KOR', code: '82' }, // Coreia do Sul
    { name: 'SAU', code: '966' }, // Arábia Saudita
    { name: 'TUR', code: '90' }, // Turquia
    { name: 'SWE', code: '46' }, // Suécia
  ];
  public columns: Array<any> = [
    { column: 'A', value: 0 },
    { column: 'B', value: 1 },
    { column: 'C', value: 2 },
    { column: 'D', value: 3 },
    { column: 'E', value: 4 },
    { column: 'F', value: 5 },
    { column: 'G', value: 6 },
    { column: 'H', value: 7 },
    { column: 'I', value: 8 },
    { column: 'J', value: 9 },
    { column: 'K', value: 10 },
    { column: 'L', value: 11 },
    { column: 'M', value: 12 },
    { column: 'N', value: 13 },
    { column: 'O', value: 14 },
    { column: 'P', value: 15 },
    { column: 'Q', value: 16 },
    { column: 'R', value: 17 },
    { column: 'S', value: 18 },
    { column: 'T', value: 19 },
    { column: 'U', value: 20 },
    { column: 'V', value: 21 },
    { column: 'W', value: 22 },
    { column: 'X', value: 23 },
    { column: 'Y', value: 24 },
    { column: 'Z', value: 25 },
  ];
  public formOficialCsv: FormGroup;
  public isScheduled: boolean = false;
  public formattedDate: string = '';
  public fileName: string = '';
  public fileNameMidia: string = '';
  public optionSelectedAddVariable: number = 0;
  public optionSelectedButton: string = '';
  public objectButtons: any;
  public midiasFiles: File[] = [];
  public errorMessage: string | null = null;
  mediaMeta: Array<{
    name: string;
    size: number;
    mimeType: string;
    width?: number;
    height?: number;
    duration?: number;
  }> = [];

  constructor(private fb: FormBuilder, private disparoService: DisparoService) {
    this.formOficialCsv = this.fb.group({
      csv: [null, [Validators.required]],
      //midia: [null, [Validators.required]],
      colunaTelefone: ['0', [Validators.required]],
      idTemplate: ['', [Validators.required]],
      tipodisparo: ['', [Validators.required]],
      data: moment().format('YYYY-MM-DD HH:mm:ss'),
      horario: [''],
      ignoreRow: [false],
      canaisIds: this.fb.array<FormControl<string>>([]),
      hComercial: [false],
      sunday: [false],
      saturday: [false],
      acceptTerm: [false],
      acceptTermPlataform: [false],
      referedVariables: this.fb.array<FormControl<number>>([]),
      campanha: ['', [Validators.required]],
    });
  }

  async ngOnInit() {
    this.getCanais();
  }

  /**
   * Funcoes de listagens pela api
   */
  public getCanais() {
    this.disparoService.getCanaisOficial().subscribe((response: any) => {
      this.listChannels = response;
    });
  }

  /**
   * Funcao para fechar o modal
   */
  public handleCloseModal(value: number) {
    this.closeModal.emit(value);
  }

  /**
   * Funcoes de avancar e retornar
   */
  public nextStep(): void {
    if (this.stepForm < 4) {
      this.stepForm++;
    }
  }

  public previousStep(): void {
    if (this.stepForm > 1) {
      this.stepForm--;
    }
  }

  /**
   * Funcao para adicionar arquivo e converter em base64
   */

  handleAddCsvFile(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) {
      this.fileName = '';
      this.formOficialCsv.patchValue({ csv: null });
      return;
    }

    // Guarda o nome do arquivo para exibir no template
    this.fileName = file.name;

    // Define o File no FormGroup (importante para o FormData)
    this.formOficialCsv.patchValue({ csv: file });
    this.formOficialCsv.get('csv')?.markAsDirty();
  }

  // handleAddMidiaFile(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   const file = input.files?.[0];

  //   if (!file) {
  //     this.fileNameMidia = '';
  //     this.formOficialCsv.patchValue({ midia: null });
  //     return;
  //   }

  //   // Guarda o nome do arquivo para exibir no template
  //   this.fileNameMidia = file.name;

  //   // Define o File no FormGroup (importante para o FormData)
  //   this.formOficialCsv.patchValue({ csv: file });
  //   this.formOficialCsv.get('csv')?.markAsDirty();
  // }

  public onFilesSelected(event: Event) {
    const list = (event.target as HTMLInputElement).files;
    if (!list || list.length === 0) return;

    const allowed = new Set([
      'application/pdf',
      'image/jpeg',
      'image/png',
      'audio/ogg',
      'video/mp4',
    ]);

    Array.from(list).forEach((file) => {
      if (!allowed.has(file.type)) {
        this.errorMessage = `Tipo não suportado: ${file.name} (${file.type})`;
        return;
      }

      this.fileNameMidia = `${file.name}`;
      this.errorMessage = '';
      this.midiasFiles.push(file);

      // cria registro de metadados
      const meta = {
        name: file.name,
        size: file.size,
        mimeType: file.type,
        width: undefined as number | undefined,
        height: undefined as number | undefined,
        duration: undefined as number | undefined,
      };
      this.mediaMeta.push(meta);

      // coletar dimensões/duração
      const url = URL.createObjectURL(file);

      if (file.type.startsWith('image/')) {
        const img = new Image();
        img.onload = () => {
          meta.width = img.width;
          meta.height = img.height;
          URL.revokeObjectURL(url);
        };
        img.src = url;
      }

      if (file.type.startsWith('video/')) {
        const video = document.createElement('video');
        video.onloadedmetadata = () => {
          meta.width = video.videoWidth;
          meta.height = video.videoHeight;
          meta.duration = Math.ceil(video.duration);
          URL.revokeObjectURL(url);
        };
        video.src = url;
      }

      if (file.type.startsWith('audio/')) {
        const audio = document.createElement('audio');
        audio.onloadedmetadata = () => {
          meta.duration = Math.ceil(audio.duration);
          URL.revokeObjectURL(url);
        };
        audio.src = url;
      }
    });
  }
  public removeMimeType(base64String: string): string {
    // Localiza a posição do delimitador `,` e retorna o conteúdo após ele
    return base64String.substring(base64String.indexOf(',') + 1);
  }

  public handleSelectChannel(event: Event) {
    const input = event.target as HTMLInputElement;
    const id = Number(input.value); // normaliza tipo (use String(...) se quiser string)

    const canaisIds = this.formOficialCsv.get('canaisIds');
    if (!(canaisIds instanceof FormArray)) {
      console.warn('canaisIds não é FormArray. Ajuste a definição do form.');
      return;
    }

    // procura índice do id (comparando por valor)
    const findIndex = () =>
      canaisIds.controls.findIndex(
        (c) => (c as FormControl<number>).value === id
      );

    if (input.checked) {
      // evita duplicidade
      if (findIndex() === -1) {
        canaisIds.push(new FormControl<number>(id));
      }
    } else {
      const idx = findIndex();
      if (idx !== -1) {
        canaisIds.removeAt(idx);
      } else {
        console.warn(`ID ${id} não encontrado em canaisIds.`);
      }
    }
  }
  /**
   * Funcoes de manipulacao de personalizacao do envio
   */

  public handleIsScheduled(event: Event): void {
    const data: any = (event?.target as HTMLInputElement).checked;

    if (data === true) {
      this.isScheduled = true;
      this.formOficialCsv.get('tipodisparo')?.setValue('AGENDADO');
      return;
    }

    this.formOficialCsv.patchValue({
      data: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.isScheduled = false;
    this.formOficialCsv.get('tipodisparo')?.setValue('NORMAL');
  }

  public handleManualyTimeData(event: Event): void {
    const hourNow: string = (event?.target as HTMLInputElement)?.value;

    const segmentHours: any = hourNow.split(' ');

    const [hour, minutes] = hourNow.split(':');

    this.formOficialCsv.patchValue({
      data: moment(
        this.formOficialCsv.get('data')?.value,
        'YYYY-MM-DD HH:mm:ss'
      )
        .hour(parseInt(hour))
        .minute(parseInt(minutes))
        .seconds(0)
        .format('YYYY-MM-DD HH:mm:ss'),
    });
  }

  public handleManualyDateData(event: Event): void {
    const dateSelected: string = (event?.target as HTMLInputElement)?.value;

    this.formattedDate = dateSelected;
    const [year, month, day] = dateSelected.split('-');

    this.formOficialCsv.patchValue({
      data: moment(
        this.formOficialCsv.get('data')?.value,
        'YYYY-MM-DD HH:mm:ss'
      )
        .date(parseInt(day))
        .month(parseInt(month) - 1)
        .year(parseInt(year))
        .format('YYYY-MM-DD HH:mm:ss'),
    });
  }

  /**
   * Funcoes para validar os steps
   */
  public handleValidStepOne(): boolean {
    if (!this.formOficialCsv.value.csv || !this.formOficialCsv.value.idTemplate)
      return false;

    return true;
  }

  public handleValidStepTwo(): boolean {
    if (this.formOficialCsv.value.canais.length === 0) return false;

    return true;
  }

  public handleValidStepThree(): boolean {
    if (!this.formOficialCsv.value.acceptTerm) return false;
    if (!this.formOficialCsv.value.acceptTermPlataform) return false;
    return true;
  }

  // public handleSubmitFire() {
  //   this.loadingModalComponent.activeLoading();
  //   switch (this.optionSelectedButton) {
  //     case 'normal':
  //       this.formOficialCsv.addControl(
  //         'buttonsConfig',
  //         new FormControl({'buttonsConfig':this.objectButtons.buttons})
  //       );
  //       break;
  //     case 'lista':
  //       this.formOficialCsv.addControl(
  //         'buttonsConfig',
  //         new FormControl({'urlButtonConfig':this.objectButtons.items})
  //       );
  //       break;
  //     case 'url':
  //       this.formOficialCsv.addControl(
  //         'buttonsConfig',
  //         new FormControl({'listConfig':this.objectButtons.buttons})
  //       );
  //       break;
  //     case 'default':

  //       break;
  //   }

  //   this.disparoService
  //     .setDisparoNormalOficial(this.formOficialCsv.value)
  //     .subscribe(
  //       (response: any) => {
  //         this.alertComponent.showAlert(
  //           'Disparo criado com sucesso!',
  //           'success'
  //         );
  //         setTimeout(() => {
  //           this.loadingModalComponent.inactiveLoading();
  //           this.handleCloseModal(2);
  //         }, 500);
  //       },
  //       (error: any) => {
  //         this.loadingModalComponent.inactiveLoading();
  //         this.alertComponent.showAlert(
  //           `Erro ao criar disparo: ${error.error.status}`,
  //           'error'
  //         );
  //       }
  //     );
  // }

  //Novo handle submit

  public handleSubmitFire() {
    if (this.loadingModalComponent?.activeLoading) {
      this.loadingModalComponent.activeLoading();
    }

    try {
      // 1) Extrai o arquivo CSV do form (File ou FileList)
      let csvFile: File | null = null;
      const csvCtrlVal = this.formOficialCsv.get('csv')?.value;

      if (csvCtrlVal instanceof File) {
        csvFile = csvCtrlVal;
      } else if (csvCtrlVal && csvCtrlVal.length > 0) {
        // caso seja FileList
        csvFile = csvCtrlVal[0];
      }

      if (!csvFile) {
        throw new Error('Selecione um arquivo CSV antes de enviar.');
      }

      // 2) Monta o buttonsConfig de acordo com a opção selecionada
      let buttonsConfig: any = undefined;
      switch (this.optionSelectedButton) {
        case 'normal':
          // backend espera algo como { buttonsConfig: [...] }
          buttonsConfig = { buttonsConfig: this.objectButtons?.buttons ?? [] };
          break;
        case 'lista':
          // backend espera { urlButtonConfig: [...] }
          buttonsConfig = { urlButtonConfig: this.objectButtons?.items ?? [] };
          break;
        case 'url':
          // backend espera { listConfig: [...] }
          buttonsConfig = { listConfig: this.objectButtons?.buttons ?? [] };
          break;
        default:
          // sem botões
          buttonsConfig = undefined;
          break;
      }

      // 3) Extrai/normaliza os demais campos do form para o JSON `dados`
      //    Ajuste os nomes para bater com o backend (canaisIds, idTemplate, etc.)
      const raw = this.formOficialCsv.value;

      // referedVariables deve ser array de índices numéricos (ou vazio)
      const referedVariables: number[] = Array.isArray(raw?.referedVariables)
        ? raw.referedVariables
            .map((v: any) => Number.parseInt(String(v), 10))
            .filter((n: number) => Number.isInteger(n) && n >= 0)
        : [];

      const dados = {
        canaisIds: raw?.canaisIds ?? [], // ex: [1,2]
        idTemplate: raw?.idTemplate ?? null, // ex: "tpl_123"
        colunaTelefone: raw?.colunaTelefone ?? 0, // ex: 0
        ignoreRow: raw?.ignoreRow ?? '0', // "1" para ignorar cabeçalho
        hComercial: !!raw?.hComercial, // boolean
        data: raw?.data ?? null, // ex: "2025-10-30 10:00:00"
        horario: raw?.horario,
        country: raw?.country ?? '55', // ex: "55"
        sunday: !!raw?.sunday, // boolean
        nome: raw?.nome ?? '', // string
        saturday: !!raw?.saturday, // boolean
        referedVariables, // array numérica
        buttonsConfig, // objeto conforme switch
        campanha: raw.campanha
      };

      // 4) Monta o FormData (NÃO defina manualmente Content-Type)
      const formData = new FormData();
      formData.append('csv', csvFile, csvFile.name);
      this.midiasFiles.forEach((f: any) => formData.append('midias', f));
      formData.append('dados', JSON.stringify(dados));

      // 5) Chama o service (que deve enviar o FormData)
      this.disparoService.setDisparoNormalOficial(formData).subscribe(
        (response: any) => {
          this.alertComponent?.showAlert?.(
            'Disparo criado com sucesso!',
            'success'
          );
          setTimeout(() => {
            this.loadingModalComponent?.inactiveLoading?.();
            this.handleCloseModal?.(2);
          }, 500);
        },
        (error: any) => {
          this.loadingModalComponent?.inactiveLoading?.();
          const msg = error?.error?.status || 'Falha ao criar disparo';
          this.alertComponent?.showAlert?.(
            `Erro ao criar disparo: ${msg}`,
            'error'
          );
        }
      );
    } catch (e: any) {
      this.loadingModalComponent?.inactiveLoading?.();
      this.alertComponent?.showAlert?.(
        e?.message || 'Erro ao processar envio',
        'error'
      );
    }
  }

  //Funcoes da nova funcionalidade de variaveis da API Oficial

  public handleAddVariableInTemplate() {
    this.referedVariables.push(
      this.fb.control(this.optionSelectedAddVariable, {
        nonNullable: true,
        validators: [Validators.required],
      })
    );
  }

  public handleRemoveVariable(index: number) {
    const arr = this.referedVariables;

    arr.removeAt(index);
  }

  public handleClearAllVariables() {
    this.referedVariables.clear();
  }

  public get referedVariables(): FormArray<FormControl<number>> {
    return this.formOficialCsv.get('referedVariables') as FormArray<
      FormControl<number>
    >;
  }

  public handleChangeOptionSelectedAddVariable(event: Event) {
    const select = event.target as HTMLSelectElement; // cast
    const value = select.value;
    this.optionSelectedAddVariable = parseInt(value);
  }

  public getTraductionColumn(value: number): string {
    return this.columns.find((element) => element.value === value)?.column;
  }

  //Funcoes dos botoes
  /*
Verifica se um botão foi selecionado na configuração.
@returns {boolean} Retorna true se um botão estiver selecionado, caso contrário, false.
*/
  public isButtonConfigured(): boolean {
    return this.optionSelectedButton.trim() !== '';
  }

  public async handleAddButtonInTemplate(typeButton: string) {
    if (!this.isButtonConfigured()) {
      this.optionSelectedButton = typeButton;
      switch (typeButton) {
        case 'normal':
          this.objectButtons = {
            title: '',
            buttons: [
              {
                text: 'Nome Botao',
                id: `${this.objectButtons?.buttons.length ?? 0}`,
              },
            ],
          };
          // Aqui você pode adicionar a lógica específica para o botão normal.
          break;

        case 'lista':
          // Aqui você pode adicionar a lógica específica para o botão de lista.
          this.objectButtons = {
            items: [
              {
                title: 'Titulo',
                description: 'Descricao',
              },
            ],
          };
          break;

        case 'url':
          // Aqui você pode adicionar a lógica específica para o botão de URL.
          this.objectButtons = {
            buttons: [
              {
                url: 'URL DO BOTAO',
                text: 'Texto',
              },
            ],
          };
          break;

        default:
          // Aqui você pode lidar com tipos de botões que não são reconhecidos.
          break;
      }
    }
  }

  public handleClearButtons() {
    this.optionSelectedButton = '';
  }

  public isObject(variable: any): boolean {
    return (
      typeof variable === 'object' &&
      variable !== null &&
      !Array.isArray(variable)
    );
  }

  public validateShowAddButton(): boolean {
    if (
      this.optionSelectedButton === 'normal' &&
      this.objectButtons.buttons.length < 3
    ) {
      return true;
    }
    return false;
  }

  public validateShowAddButtonList() {
    if (
      this.optionSelectedButton === 'lista' &&
      this.objectButtons.items.length < 5
    ) {
      return true;
    }
    return false;
  }

  public validateShowAddButtonUrl() {
    if (
      this.optionSelectedButton === 'url' &&
      this.objectButtons.buttons.length < 1
    ) {
      return true;
    }
    return false;
  }

  public handleAddButton() {
    switch (this.optionSelectedButton) {
      case 'normal':
        this.objectButtons.buttons.push({
          text: 'Padrao',
          id: `${this.objectButtons.buttons.length}`,
        });
        break;
      case 'lista':
        this.objectButtons.items.push({
          title: 'Titulo',
          description: 'Descricao',
        });
        break;
      case 'url':
        this.objectButtons.buttons.push({
          url: 'Url',
          text: 'Texto',
        });
        break;
      default:
        break;
    }
  }

  public handleRemoveButton(index: number) {
    this.objectButtons.buttons.splice(index, 1);
  }

  public handleRemoveItemList(index: number) {
    this.objectButtons.items.splice(index, 1);
  }

  public handleRemoveButtonUrl(index: number) {
    this.objectButtons.buttons.splice(index, 1);
  }

  public handleShowTerm() {}
  //Validacoes para adicionar botoes
}
